module.exports = __webpack_public_path__ + "img/logo_android_verde.c2bce88c.png";